import React from 'react';
import { Box, Typography } from '@mui/material';

import { CloseButton, Dialog, DialogContent, DialogTitle } from 'components';

interface UsersInvitedDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  succeed?: string[];
  failed?: string[];
}

export const UsersInvitedDialog = ({
  visible = false,
  setVisible = () => {},
  succeed = [],
  failed = [],
}: UsersInvitedDialogProps) => {
  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const renderEmails = (emails: Array<string>) => (
    <Box sx={{ paddingY: 2 }}>
      {emails.map((email) => (
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            marginY: 1,
          }}
        >
          {email}
        </Typography>
      ))}
    </Box>
  );

  return (
    <Dialog onClose={onClose} open={visible} fullScreen={false}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          Invite Users
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ paddingTop: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {succeed.length > 0 && (
            <Box sx={{ width: '100%' }}>
              <Typography sx={{ color: '#4caf50' }}>
                {`Successfully invited below user${succeed.length > 1 ? 's' : ''}.`}
              </Typography>

              {renderEmails(succeed)}
            </Box>
          )}

          {failed.length > 0 && (
            <Box sx={{ width: '100%' }}>
              <Typography sx={{ color: '#d32f2f' }}>
                {`Failed to send email to invite below user${failed.length > 1 ? 's' : ''}.`}
              </Typography>
              <Typography sx={{ color: '#d32f2f' }}>
                {`The email${failed.length > 1 ? 's are' : ' is'} already registered in the system.`}
              </Typography>

              {renderEmails(failed)}
            </Box>
          )}
        </Box>
      </DialogContent>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
